import { render, staticRenderFns } from "./TablesManage.vue?vue&type=template&id=6cdd7cb0&"
import script from "./TablesManage.vue?vue&type=script&lang=js&"
export * from "./TablesManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports